import React, { useRef, useState, useEffect, useCallback } from "react";
import Input from "../common/Input";
import styles from "./DateInputWrapper.module.css";
import DateWheelPicker from ".";
import { getZodiacSign } from "../../utils/zodiacUtils";
import Button from "../common/Button";

interface DateInputWrapperProps {
  value: string;
  onChange: (date: Date, zodiacSign: string) => void;
  disabled?: boolean;
  initialDate?: Date;
  context?: "onboarding" | "profile";
}

const DateInputWrapper: React.FC<DateInputWrapperProps> = ({
  value,
  onChange,
  disabled = false,
  initialDate,
  context,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempDate, setTempDate] = useState(() =>
    initialDate
      ? new Date(
          initialDate.getFullYear(),
          initialDate.getMonth(),
          initialDate.getDate(),
          12,
          0,
          0,
          0
        )
      : new Date()
  );

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleSelect = useCallback((date: Date) => {
    setTempDate(date);
  }, []);

  const handleConfirm = () => {
    const zodiac = getZodiacSign(tempDate);
    onChange(tempDate, zodiac);
    setIsOpen(false);
  };

  useEffect(() => {
    if (!initialDate) return;
    const normalized = new Date(
      initialDate.getFullYear(),
      initialDate.getMonth(),
      initialDate.getDate(),
      12,
      0,
      0,
      0
    );
    setTempDate(normalized);
  }, [initialDate]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <Input
        type="text"
        readOnly
        value={value}
        onClick={() => !disabled && setIsOpen(true)}
        placeholder="ДД.ММ.ГГГГ"
        disabled={disabled}
      />
      {isOpen && (
        <div
          className={`${styles.pickerWrapper} ${context === "onboarding" ? styles.onboarding : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <DateWheelPicker onSelect={handleSelect} initialDate={tempDate} />
          <div className={styles.confirmBtn}>
            <Button onClick={handleConfirm}>Выбрать</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateInputWrapper;
